import React from 'react';
import SvgIcon from './SvgIcon';

function ShowMoreLoaderComponent() {
  return (
    <button type="button" className="c-btn c-btn--default c-btn--loading">
      <span className="u-justify-center">
        <SvgIcon
          id="icon-refresh"
          width="24px"
          height="24px"
          className="loader-icon"
        />
        Loading...
      </span>
    </button>
  );
}

export default ShowMoreLoaderComponent;
